import { createSelector } from '../selectorWrapper'
import { detailPagePath } from '../../utils/url'
import { urlMakerSelector, MakeUrl } from '../requestContext'
import { WatchlistToggleInput } from 'DVWebNodeUtils'
import { pageSelectors } from '../basicState'
import { WatchlistDetail } from '../../reducers/watchlist'


const generateWatchlistRefTag = (tag: string, isSeason: boolean) => {
  const action = tag === 'Remove' ? 'rmv' : 'add'
  const type = isSeason ? 'seas' : 'mov'
  return `atv_dp_wtls_${action}_${type}`
}

const getWatchlistPartialURL = (watchlistFragment: WatchlistDetail, isSeason: boolean) => {
  const tag = watchlistFragment.tag
  const refTag = generateWatchlistRefTag(tag, isSeason)
  const pURL = watchlistFragment.endpoint.partialURL || ''
  return pURL.replace('atv_unknown', refTag)
}

export const watchlistComponentSelector = createSelector(
  [urlMakerSelector, pageSelectors.watchlist],
  (makeUrl: MakeUrl, watchlistFragment?: WatchlistDetail) => {

    if (!watchlistFragment) {
      return undefined
    }

    const endpointQuery = watchlistFragment.endpoint.query
    const isSeason = endpointQuery.titleType === 'season'
    const partialURL = getWatchlistPartialURL(watchlistFragment, isSeason)

    const query = {
      returnUrl: makeUrl(detailPagePath(endpointQuery.titleID), { refTag: 'atv_wl_tog_sign_in' }),
      ...endpointQuery as WatchlistToggleInput
    }

    return {
      partialURL,
      query,
      isSeason,
      tag: watchlistFragment.tag,
      text: watchlistFragment.text,
      ajaxEnabled: watchlistFragment.ajaxEnabled,
      failed: Boolean(watchlistFragment.failed)
    }
  }
)
